export default __webpack_public_path__ + "static/media/instagram_sc_4.5666ec71.png";